/*
  Extracted code from $http $$CookieReader
  https://github.com/angular/angular.js/blob/26a5779cddf70944b7548e3a6410d35237a516e5/src/ng/cookieReader.js
*/
export class CookieReaderHelper {
  private rawDocument: Document = window.document;
  private lastCookies: Record<string, any> = {};
  private lastCookieString: string = '';

  constructor() {
    let cookieArray: any = [];
    let cookie = '';
    let i = 0;
    let index = -1;
    let name;
    const currentCookieString = CookieReaderHelper.safeGetCookie(this.rawDocument);

    if (currentCookieString !== this.lastCookieString) {
      this.lastCookieString = currentCookieString;
      cookieArray = this.lastCookieString.split('; ');
      this.lastCookies = {};

      for (i = 0; i < cookieArray.length; i++) {
        cookie = cookieArray[i];
        index = cookie.indexOf('=');
        if (index > 0) {
          // ignore nameless cookies
          name = CookieReaderHelper.safeDecodeURIComponent(cookie.substring(0, index));
          // the first value that is seen for a cookie is the most
          // specific one.  values for the same cookie name that
          // follow are for less specific paths.
          if (this.lastCookies[name] === undefined) {
            this.lastCookies[name] = CookieReaderHelper.safeDecodeURIComponent(cookie.substring(index + 1));
          }
        }
      }
    }
    return this;
  }

  getCookies() {
    return this.lastCookies;
  }

  getCookie(cookieName: string) {
    return this.lastCookies[cookieName];
  }

  static safeGetCookie(rawDoc: Document) {
    try {
      return rawDoc.cookie || '';
    } catch (e) {
      return '';
    }
  }

  static safeDecodeURIComponent(str: string) {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      return str;
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/helpers/cookie_reader_helper.ts